import { DelegateType, DialogMessageType } from '../../shared/models/utility.model';
import { WizardState } from '../../kamona/model/kamonal-model';

export enum MobileWebViewEnums {
	PASSWORD,
	// FINGER_PRINT,
	// FACE_ID,
	// LOADING_BIOMETRIC
}

export enum NotificationType {
	EVENT = 'EVENT',
}

export class SignupForm {
	state: WizardState;
	key: SignupFormKey;

	constructor(key: SignupFormKey) {
		this.key = key;
		this.state = WizardState.INACTIVE;
	}
}
export interface MoniepointAppParameters {
	hasSetupBiometric: boolean;
	biometricType: any;
	appVersion?: any;
	userAgent?: any;
	isWebUniqueIdentifier?: boolean;
	deviceRegistrationRequest: DeviceRegistrationRequest;
}

export const DefaultMoniepointAppParameters: MoniepointAppParameters = {
	hasSetupBiometric: false,
	biometricType: 'NONE',
	userAgent: null,
	isWebUniqueIdentifier: false,
	appVersion: '',
	deviceRegistrationRequest: {
		deviceUniqueIdentifier: null,
		manufacturer: null,
		model: null,
		username: null,
	},
};

export interface DeviceRegistrationRequest {
	deviceUniqueIdentifier: string;
	manufacturer: string;
	model: string;
	username: string;
}

export class MobileWebViewDialer {
	constructor() {}

	lunchDialer(dialCode) {
		try {
			window[`flutter_inappwebview`]
				.callHandler(DelegateType.launchDialer, dialCode)
				.then(() => {})
				.catch((error) => {
					console.log('error from launchDialer', error);
				});
		} catch (error) {
			console.log('Error lunching dialer', error);
		}
	}
}

export class AccountCreationData {
	phoneVerificationFormData: PhoneVerificationFormData;
	otpVerificationFormData: OtpVerificationFormData;
	bvnVerificationFormData: BvnVerificationFormData;
	createProfileFormData: CreateProfileFormData;
}

export class PhoneVerificationFormData extends SignupForm {
	phoneNumber: string;
	email: string;

	constructor(phoneNumber, email) {
		super(SignupFormKey.PHONE_VERIFICATION);
		this.phoneNumber = phoneNumber;
		this.email = email;
		this.state = WizardState.INACTIVE;
	}
}

export class OtpVerificationFormData extends SignupForm {
	validationKey: string;

	constructor(validationKey: string) {
		super(SignupFormKey.OTP_VALIDATION);
		this.validationKey = validationKey;
		this.state = WizardState.INACTIVE;
	}
}

export class BusinessNameFormData extends SignupForm {
	businessName: string;

	constructor(businessName) {
		super(SignupFormKey.BUSINESS_NAME);
		this.businessName = businessName;
		this.state = WizardState.INACTIVE;
	}
}

export class BvnVerificationFormData extends SignupForm {
	bvnOnbaordingKey: string;
	bvn: string;
	dateOfBirth: any;

	constructor(bvn, dateOfBirth, bvnOnbaordingKey) {
		super(SignupFormKey.BVN_VERIFICATION);
		this.bvn = bvn;
		this.dateOfBirth = dateOfBirth;
		this.bvnOnbaordingKey = bvnOnbaordingKey;
		this.state = WizardState.INACTIVE;
	}
}

export class CreateProfileFormData extends SignupForm {
	deviceUniqueIdentifier: string;
	emailAddress: string;
	manufacturer: string;
	model: string;
	password: string;
	transactionPin: string;
	username: string;
	validationKey: string;

	constructor() {
		super(SignupFormKey.CREATE_PROFILE);
		this.state = WizardState.INACTIVE;
	}
}

export class SignupMessageFormData extends SignupForm implements SignupResponseData {
	responseData: any;
	username: string;
	description: string;
	title: string;
	messageType: DialogMessageType;
	buttonName: string;

	constructor() {
		super(SignupFormKey.MESSAGE);
	}
}

export interface SignupResponseData extends MessageData {
	responseData: any;
	username: string;
}

export class MessageData {
	description: string;
	title: string;
	messageType: any;
	buttonName: string;
}

export class PhoneValidationMessage implements MessageData {
	buttonName: string;
	description: string;
	messageType: any;
	title: string;
	expiryTime: any;
	step: number;
}

export enum SignupFormKey {
	PHONE_VERIFICATION = 'PHONE_VERIFICATION',
	OTP_VALIDATION = 'OTP_VALIDATION',
	BVN_VERIFICATION = 'BVN_VERIFICATION',
	BUSINESS_NAME = 'BUSINESS_NAME',
	CREATE_PROFILE = 'CREATE_PROFILE',
	MESSAGE = 'MESSAGE',
	ENTER_EMAIL = 'ENTER_EMAIL',
	CREATE_PASSCODE = 'CREATE_PASSCODE',
	USER_PIN = 'USER_PIN',
}

export class WebChannel {
	private readonly eventType: WebChannelEventType;
	private readonly response: any;

	constructor(eventType, response) {
		this.eventType = eventType;
		this.response = response;
	}

	getEventType() {
		return this.eventType;
	}

	getResponse() {
		return this.response;
	}

	getLink(params: any) {
		return '';
	}
}

export class NotificationWebChannel extends WebChannel {
	getLink(params: any) {
		return `/notification-center?notification=${params}`;
	}
}

export enum WebChannelEventType {
	NOTIFICATION_EVENT = 'NOTIFICATION_EVENT',
}
